import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  StudentGradeUnitListItemDTO,
  IStudentGradeUnitListItemDTO,
} from '@models/grade-unit/student-grade-unit';

import * as GradeUtils from '@utils/grade-utils';

@Component({
  selector: 'app-student-grade-unit',
  template: `
    <app-student-grade-unit-presentation
      [gradeUnit]="gradeUnit"
      [scorePreview]="scorePreview"
      (emitNavigateToAssignedUnitDays)="navigateToAssignedUnitDays()"
    ></app-student-grade-unit-presentation>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StudentGradeUnitSmartComponent {
  @Input() public gradeUnit: IStudentGradeUnitListItemDTO =
    new StudentGradeUnitListItemDTO();
  @Input() public scorePreview: boolean = false;

  constructor(private router: Router) {}

  public navigateToAssignedUnitDays(): void {
    const gradeLevel = GradeUtils.gradeLevelToNumber(
      this.gradeUnit.unitGradeLevel,
    );
    const dayListPath = `${this.router.url}/grades/${gradeLevel}/units/${this.gradeUnit.unitNumber}/days`;
    this.router.navigateByUrl(dayListPath);
  }
}
